module.exports = __webpack_public_path__ + "static/media/scene-icon.80744d8f.svg";